import * as React from 'react'

import { ProductReviewsContainer } from '../../../../../containers/ProductReviewsContainer'
import { ReviewsProductGroupDataProvider } from '../../../../../containers/ReviewsProductGroupDataService/useReviewsProductGroupData'

import { Template } from './Template'
import { useViewModel } from './useViewModel'

const ReviewsPageViewWithoutProviders: React.FC<{
  handle: string
  writeReview: boolean
}> = ({ handle, writeReview }) => {
  const viewModel = useViewModel({ writeReview })

  return <Template handle={handle} {...viewModel} />
}

export const ReviewsPageView: React.FC<{
  handle: string
  writeReview: boolean
}> = ({ handle, writeReview }) => {
  return (
    <ReviewsProductGroupDataProvider handle={handle}>
      <ProductReviewsContainer.Provider>
        <ReviewsPageViewWithoutProviders handle={handle} writeReview={writeReview} />
      </ProductReviewsContainer.Provider>
    </ReviewsProductGroupDataProvider>
  )
}

export default ReviewsPageView
